module.exports = __webpack_public_path__ + "img/logo_acimcol.1c6a90f.png";